import { Link } from "react-router";
import { ArrowLeft } from "lucide-react";
import logoIcon from "@/assets/cyphron_logo/logo-icon.svg";

interface LegalLayoutProps {
  title: string;
  lastUpdated: string;
  children: React.ReactNode;
}

export function LegalLayout({ title, lastUpdated, children }: LegalLayoutProps) {
  return (
    <div className="min-h-screen bg-[#030712] text-[#F8FAFC]">
      <header className="sticky top-0 z-50 bg-[#030712]/95 backdrop-blur-md border-b border-[#84FF00]/[0.06]">
        <div className="max-w-4xl mx-auto px-6 h-16 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2.5 group">
            <img
              src={logoIcon}
              alt="Cyphron"
              className="h-7 w-7 rounded-md transition-transform duration-300 group-hover:scale-105"
            />
            <span
              className="font-bold text-lg tracking-tight"
              style={{ fontFamily: "'Rajdhani', sans-serif" }}
            >
              Cyphron
            </span>
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-[13px] font-medium text-[#94A3B8] hover:text-[#F8FAFC] transition-colors"
          >
            <ArrowLeft size={14} />
            Voltar ao site
          </Link>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 pt-12 pb-20">
        <div className="mb-10">
          <h1
            className="text-3xl md:text-4xl font-bold tracking-tight mb-3"
            style={{ fontFamily: "'Rajdhani', sans-serif" }}
          >
            {title}
          </h1>
          <p className="text-[13px] text-[#64748B]">
            Última atualização: {lastUpdated}
          </p>
        </div>

        <article className="legal-prose">{children}</article>
      </main>

      <footer className="border-t border-white/[0.05] py-8 px-6">
        <div className="max-w-4xl mx-auto flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <p className="text-[12px] text-[#334155]">
            {new Date().getFullYear()} Cyphron. Todos os direitos reservados.
          </p>
          <div className="flex items-center gap-5">
            <Link
              to="/termos"
              className="text-[12px] text-[#64748B] hover:text-[#F8FAFC] transition-colors"
            >
              Termos de Uso
            </Link>
            <Link
              to="/privacidade"
              className="text-[12px] text-[#64748B] hover:text-[#F8FAFC] transition-colors"
            >
              Política de Privacidade
            </Link>
            <a
              href="mailto:support@cyphronsec.com"
              className="text-[12px] text-[#64748B] hover:text-[#F8FAFC] transition-colors"
            >
              support@cyphronsec.com
            </a>
          </div>
        </div>
      </footer>
    </div>
  );
}
